/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Broker_Action_UnresolvedInputs */

const cs_import_broker_action_unresolved = /** @type {(inputs: Import_Broker_Action_UnresolvedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neznámý`)
};

const en_import_broker_action_unresolved = /** @type {(inputs: Import_Broker_Action_UnresolvedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unresolved`)
};

/**
* | output |
* | --- |
* | "Unresolved" |
*
* @param {Import_Broker_Action_UnresolvedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_broker_action_unresolved = /** @type {((inputs?: Import_Broker_Action_UnresolvedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Broker_Action_UnresolvedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_broker_action_unresolved(inputs)
	return cs_import_broker_action_unresolved(inputs)
});